var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('Login',{attrs:{"logo":_vm.logo,"cover":_vm.$root.isMobile ? _vm.introCoverMobile : _vm.introCover}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }